"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Debug = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const PageBanner_1 = require("src/hello_assets/src/components/ui/common/content/PageBanner");
const use_query_params_1 = require("use-query-params");
const Debug = (props) => {
    const [query, setQuery] = (0, use_query_params_1.useQueryParams)({ state: use_query_params_1.JsonParam });
    return React.createElement(React.Fragment, null,
        React.createElement(PageBanner_1.PageBanner, null,
            React.createElement(antd_1.Alert, { type: "error", message: "Error message" }, "Child")),
        React.createElement(antd_1.PageHeader, { title: "Debug" }),
        React.createElement(PageContent_1.default, null,
            React.createElement(PageContent_1.default.CardSpacer, null),
            React.createElement(PageContent_1.default.Card, null,
                React.createElement(PageContent_1.default.CardSection, null, "Title"),
                "Debug Page",
                React.createElement("br", null),
                "query a=",
                JSON.stringify(query.state),
                React.createElement("br", null),
                React.createElement(antd_1.Button, { onClick: () => {
                        setQuery({ state: { time: new Date().getTime(), "ф": "ывфыв" } });
                    } }, "click"))));
};
exports.Debug = Debug;
